import React from 'react';

import { RowActionConfig } from '@sbu/components.datagrid';
import {
  DataGridAside,
  DataGridAsideActions,
  DataGridAsideAttribute,
  DataGridAsideContent,
  DataGridAsideTitle,
} from '@sbu/components.datagridaside';

import { InsightResolutionsAsideForm } from './InsightResolutionsAsideForm';
import { useInsightResolutionsContext } from './InsightResolutionsContext';
import { InsightResolutionRow, isParentResolution } from './types';
import { getParentResolution } from './utils';

export interface InsightResolutionsAsideProps {
  rowActions?: RowActionConfig<InsightResolutionRow>[];
  parentResolutions?: InsightResolutionRow[];
}

export const InsightResolutionsAside = ({
  rowActions = [],
  parentResolutions,
}: InsightResolutionsAsideProps) => {
  const { onCloseAside, asideState, selectedRow } =
    useInsightResolutionsContext();

  const parentResolution = getParentResolution(selectedRow, parentResolutions);

  return (
    <DataGridAside
      data-sumo-test='insight-resolution-aside'
      onClose={onCloseAside}
    >
      <DataGridAsideTitle
        state={asideState}
        row={selectedRow}
        getObjectName={(data) => data.name}
        objectType='Insight Resolution'
      />
      {asideState === 'read' && selectedRow && (
        <>
          <DataGridAsideActions
            state={asideState}
            rowActions={rowActions}
            row={selectedRow}
            onCancel={onCloseAside}
          />
          <DataGridAsideContent>
            {!isParentResolution(selectedRow) && (
              <DataGridAsideAttribute
                data-sumo-test='insight-resolution-parent'
                label='Parent Resolution'
                value={parentResolution?.name}
              />
            )}
            <DataGridAsideAttribute
              data-sumo-test='insight-resolution-description'
              label='Description'
              value={selectedRow.description}
            />
          </DataGridAsideContent>
        </>
      )}
      {(asideState === 'create' || asideState === 'update') && (
        <InsightResolutionsAsideForm
          rowActions={rowActions}
          parentResolutions={parentResolutions}
        />
      )}
    </DataGridAside>
  );
};
